import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class Complete {
  /**
   * 受付データ取得
   * @param {Number} receptionId 受付ID
   * @return {Promise<Object>} 受付データ
   */
  getReception = async (receptionId) => {
    const result = await requestManager.post(`${API_PATH}/cmplt/r`, {
      receptionId,
    });
    return result.data;
  };

  getRsvSetting = async (rsvSetId = null) => {
    const filter = { rsv_set_id: rsvSetId, enable: true };
    const params = { filter };
    const result = await requestManager.get(`${API_PATH}/cmplt/r/reserve-setting`, params);
    return result.data;
  };

  /**
   * メールの再送
   * @param {number} receptionId
   * @returns
   */
  resendMail = async (receptionId) => {
    const result = await requestManager.put(`${API_PATH}/cmplt/u/resend-mail`, {
      receptionId,
    });
    return result.data;
  };

  /**
   * SMSの再送
   * @param {number} receptionId
   * @returns
   */
  resendSms = async (receptionId) => {
    const result = await requestManager.put(`${API_PATH}/cmplt/u/resend-sms`, {
      receptionId,
    });
    return result.data;
  };

  /**
   * メールアドレスの更新
   * @param {number} receptionId
   * @param {string} newMailAddress
   * @returns
   */
  updateMail = async (receptionId, newMailAddress) => {
    const result = await requestManager.put(`${API_PATH}/cmplt/u/update-mail-address`, {
      receptionId,
      newMailAddress,
    });
    return result.data;
  };

  /**
   * 電話番号の更新
   * @param {number} receptionId
   * @param {string} newTelNum
   * @returns
   */
  updateSms = async (receptionId, newTelNum) => {
    const result = await requestManager.put(`${API_PATH}/cmplt/u/update-tel-num`, {
      receptionId,
      newTelNum,
    });
    return result.data;
  };
}

const instance = new Complete();
instance.Constructor = Complete;

export default instance;
